export class NpDetailsModel {

    public id: number;
    public firstName: string;
    public middleName: string;
    public lastName: string;
    public note: string;
    public noteUpdatedBy: string;
    public countryId: number;
    public occupationId: number;
    public pep: string;
    public personalNumber: string;

    constructor(obj?: any) {
        this.id                 = obj && obj.id                 || null;
        this.firstName          = obj && obj.firstName          || '';
        this.middleName         = obj && obj.middleName         || '';
        this.lastName           = obj && obj.lastName           || '';
        this.note               = obj && obj.note               || '';
        this.noteUpdatedBy      = obj && obj.noteUpdatedBy      || '';
        this.countryId          = obj && obj.countryId          || null;
        this.occupationId       = obj && obj.occupationId     || null;
        this.pep                = obj && obj.pep                || '';
        this.personalNumber     = obj && obj.personalNumber     || '';
    }
}



// WEBPACK FOOTER //
// ./src/app/models/np-details.model.ts